export function formatPhoneNumber(phoneNumber?: string): string | undefined {
  return phoneNumber?.replace(/[^0-9]/g, ``).replace(/([0-9]{3})([0-9]{3})([0-9]{4})/, `($1) $2-$3`)
}
